<template>
    <div class="banner-wrap">
        <bread-crumb :bread-list="breadList" />

        <div class="banner-content">
            <div class="title-wrap">
                <i class="iconfont icon-tongyongbiaotiicon"></i>
                <span class="title-text">banner管理</span>
            </div>
            <div class="search-wrap">
                <div class="search-show-wrap">
                    <el-input class="search-input"
                              size="small"
                              placeholder="请输入banner名称"
                              v-model="selectForm.bannerTitle"
                              @keyup.enter.native="handleSearch">
                        <i slot="suffix"
                           class="iconfont icon-search"
                           @click="handleSearch"></i>
                    </el-input>
                    <div class="more-search"
                         @click="isMoreShow=!isMoreShow">
                        <span class="more-search-text">高级搜索</span>
                        <i class="iconfont icon-drop_down"
                           :class="[{'is-reverse': isMoreShow}]"></i>
                    </div>
                </div>
                <el-button size="small"
                           @click="handleAddBanner">新增banner</el-button>
            </div>

            <div class="hide-wrap"
                 v-if="isMoreShow">
                <div class="option-wrap">

                    <div class="option-item">
                        <span class="label">banner名称</span>
                        <el-input placeholder="请输入banner名称"
                                  :style="{width: '240px'}"
                                  v-model="selectForm.bannerTitle">
                        </el-input>
                    </div>
                    <div class="option-item">
                        <span class="label">状态</span>
                        <el-select v-model="selectForm.status"
                                   placeholder="请选择"
                                   size="small"
                                   clearable
                                   :style="{width: '240px'}"
                                   @change="selectChange">
                            <el-option label="全部"
                                       value="">
                            </el-option>
                            <el-option label="已上线"
                                       :value="true">
                            </el-option>
                            <el-option label="未上线"
                                       :value="false">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="option-item">
                        <span class="label">上传人员</span>
                        <el-input placeholder="请输入上传人员"
                                  :style="{width: '240px'}"
                                  v-model="selectForm.uploader">
                        </el-input>
                    </div>
                    <div class="option-item">
                        <span class="label">上线时间</span>
                        <el-date-picker size="small"
                                        clearable
                                        clear-icon="el-icon-error"
                                        v-model="selectForm.addedTime"
                                        type="daterange"
                                        range-separator="-"
                                        start-placeholder="yyyy-mm-dd"
                                        end-placeholder="yyyy-mm-dd"
                                        value-format="yyyy-MM-dd"
                                        :style="{width: '240px'}"
                                        :picker-options="datePickerOptions">
                        </el-date-picker>
                    </div>

                    <div class="option-item">
                        <span class="label">创建时间</span>
                        <el-date-picker size="small"
                                        clearable
                                        clear-icon="el-icon-error"
                                        v-model="selectForm.createTime"
                                        type="daterange"
                                        range-separator="-"
                                        start-placeholder="yyyy-mm-dd"
                                        end-placeholder="yyyy-mm-dd"
                                        value-format="yyyy-MM-dd"
                                        :style="{width: '240px'}"
                                        :picker-options="datePickerOptions">
                        </el-date-picker>
                    </div>
                    <div class="select-btn-wrap">
                        <el-button type="primary"
                                   size="small"
                                   @click="handleSearch">查询</el-button>
                        <el-button type="info"
                                   size="small"
                                   plain
                                   @click="resetSearch">重置</el-button>
                    </div>
                </div>
            </div>

            <div class="table-wrap">
                <el-table :data="dataList"
                          v-loading="loading"
                          stripe
                          style="width: 100%">
                    <el-table-column min-width="60px"
                                     label="序号">
                        <template slot-scope="scope">
                            <span>{{  scope.$index + (page.current - 1) * page.pageSize + 1 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column width="250px"
                                     label="banner">
                        <template slot-scope="scope">
                            <div class="image_title">
                                <el-image v-if="scope.row.coverPicture"
                                          class="cover-picture"
                                          :src="'/ms-hoc-video/v1/image/download?fileName='+ scope.row.coverPicture">
                                </el-image>
                                <div class="text_title">
                                    <span class="image_text">{{ scope.row.bannerTitle || '-' }}</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="url"
                                     min-width="180px"
                                     label="URL">
                        <template slot-scope="scope">
                            <span>
                                {{ scope.row.url || '-'}}
                            </span>
                        </template>
                    </el-table-column>

                    <el-table-column min-width="130px"
                                     label="上线时间">
                        <template slot-scope="scope">
                            <span v-if="scope.row.addedTime">
                                {{ scope.row.addedTime|formatDate }}
                            </span>
                            <span v-else>
                                -
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="130px"
                                     label="下线时间">
                        <template slot-scope="scope">
                            <span v-if="scope.row.dismountedTime">
                                {{ scope.row.dismountedTime|formatDate }}
                            </span>
                            <span v-else>
                                -
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="140px"
                                     label="创建时间">
                        <template slot-scope="scope">
                            <span v-if="scope.row.createTime">
                                {{ scope.row.createTime|formatDate }}
                            </span>
                            <span v-else>
                                -
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="80px"
                                     label="点击数">
                        <template slot-scope="scope">
                            <span>
                                {{ scope.row.clickNum || '-'}}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="80px"
                                     label="分享数">
                        <template slot-scope="scope">
                            <span>
                                {{ scope.row.shareNum || '-'}}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="uploader"
                                     width="80px"
                                     label="上传人员">
                    </el-table-column>
                    <el-table-column width="120px"
                                     label="状态">
                        <template slot-scope="scope">
                            <div v-if="scope.row.status"
                                 class="status-warp">
                                <el-badge is-dot
                                          type="success"
                                          class="item">
                                </el-badge>
                                <span class="status_text">已上线</span>
                            </div>
                            <div v-else
                                 class="status-warp">
                                <el-badge is-dot
                                          type="info"
                                          class="item">
                                </el-badge>
                                <span class="status_text">未上线</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right"
                                     label="排序"
                                     width="90">
                        <template slot-scope="scope">
                            <div v-if="scope.row.status && isStatsShow"
                                 class="status-on">
                                <i class="iconfont icon-paixushang icon-off"
                                   v-if="scope.row.noMoveUp"></i>
                                <i class="iconfont icon-paixushang icon-on"
                                   v-else
                                   @click="handleMoveUp(scope.row.bannerId)"></i>

                                <i class="iconfont icon-paixuxia icon-off"
                                   v-if="scope.row.noMoveDown"></i>
                                <i class="iconfont icon-paixuxia icon-on"
                                   v-else
                                   @click="handleMoveDown(scope.row.bannerId)"></i>
                            </div>
                            <div v-else
                                 class="status-off">
                                <i class="iconfont icon-paixushang"></i>
                                <i class="iconfont icon-paixuxia"></i>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column fixed="right"
                                     label="操作"
                                     width="135">
                        <template slot-scope="scope">
                            <div v-if="scope.row.status">
                                <span @click="handleDismountedBanner(scope.row.bannerId)"
                                      class="link-btn">下线</span>
                            </div>
                            <div v-else>
                                <span @click="handleShelfBanner(scope.row.bannerId)"
                                      class="link-btn">上线</span>

                                <span @click="handleEditorBanner(scope.row.bannerId)"
                                      class="link-btn">编辑</span>
                                <span @click="hanldeDialogVisible(scope.row)"
                                      class="link-btn">删除</span>
                            </div>
                        </template>
                    </el-table-column>
                    <div slot="empty"
                         class="table-none">
                        <div>
                            <svg-icon icon-class="none1" />
                        </div>
                        <span>暂无数据</span>
                    </div>
                </el-table>
            </div>
            <div class="pagination-wrap">
                <el-pagination background
                               @current-change="handleCurrentChange"
                               :current-page.sync="page.current"
                               :page-size="page.pageSize"
                               layout="total, prev, pager, next, jumper"
                               :total="page.total">
                </el-pagination>
            </div>
        </div>
        <message-box :dialog-visible="dialogVisible"
                     :id="bannerId"
                     warning-text="确认将此banner删除？"
                     @handleConfirm="handleConfirm"
                     @handleClose="handleClose" />
    </div>
</template>

<script>
import MessageBox from '@/components/MessageBox'
import shortcuts from '@/utils/pickerOptions'
import { postBannerList, deleteBanner, postDismountedBanner, postShelfBanner, getBannerMoveUp, getBannerMoveDown } from '@/api/banner'
export default {
    name: 'banner',
    data () {
        return {
            loading: false,
            dialogVisible: false,
            datePickerOptions: {
                shortcuts: shortcuts
            },
            breadList: [
                { label: '运营管理' },
                { label: 'banner管理' }
            ],
            isMoreShow: false,
            dataList: [],
            bannerId: '',
            selectForm: {
                bannerTitle: '',
                status: '',
                uploader: '',
                createTime: '',
                addedTime: ''
            },
            page: {
                current: 1,
                total: 1,
                pageSize: 10
            },
            isStatsShow: true
        }
    },
    components: {
        MessageBox
    },
    filters: {
        formatDate (value) {
            if (value) {
                return value.substring(0, 16)
            } else {
                return ''
            }
        }
    },
    methods: {
        async handleMoveUp (bannerId) {
            const { state } = await getBannerMoveUp(bannerId)
            if (state === 200) {
                this.query(this.page.current)
            }
        },
        async handleMoveDown (bannerId) {
            const { state } = await getBannerMoveDown(bannerId)
            if (state === 200) {
                this.query(this.page.current)
            }
        },
        handleClose () {
            this.dialogVisible = false
        },
        handleConfirm (bannerId) {
            this.loading = true
            this.dialogVisible = false
            this.handleDeleteBanner(bannerId)
        },
        handleAddBanner () {
            this.$router.push('/operation/banner/add')
        },
        handleEditorBanner (bannerId) {
            this.$router.push({ path: '/operation/banner/editor', query: { bannerId: bannerId } })
        },
        handleCurrentChange (val) {
            this.query(val)
        },
        hanldeDialogVisible (row) {
            this.bannerId = row.bannerId
            this.dialogVisible = true
        },
        async handleDeleteBanner (bannerId) {
            const { state } = await deleteBanner(bannerId)
            if (state === 200) {
                this.$message({
                    message: '删除banner成功',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '1000'
                })
                this.query(this.page.current)
            }
        },
        async handleDismountedBanner (bannerId) {
            this.loading = true
            const { results, state } = await postDismountedBanner(bannerId)
            if (results === 'successed' && state === 200) {
                this.$message({
                    message: 'banner下线成功',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '1000'
                })
                this.query(this.page.current)
            } else {
                this.$message.error('下线失败,稍后重试')
                this.loading = false
            }
        },
        async handleShelfBanner (bannerId) {
            this.loading = true
            const { results } = await postShelfBanner(bannerId)
            if (results === 'successed') {
                this.$message({
                    message: 'banner上线成功',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '1000'
                })
                this.query(this.page.current)
            } else if (results === 'failed') {
                this.$message.error('上线失败：最多上线五个banner')
                this.loading = false
            }
        },
        resetSearch () {
            this.selectForm = {
                status: '',
                uploader: '',
                createTime: '',
                addedTime: ''
            }
            this.query(1)
        },
        handleSearch () {
            this.query(1)
        },
        selectChange () {
            this.query(1)
        },
        query (current) {
            this.page.current = current
            this.queryBannerList()
        },
        queryShow () {
            const { bannerTitle, status, uploader, createTime, addedTime } = this.selectForm
            let flag = bannerTitle || status || uploader || createTime || addedTime
            this.isStatsShow = !flag
        },
        async queryBannerList () {
            let addedTimeStart = ''
            let addedTimeEnd = ''
            if (this.selectForm.addedTime) {
                addedTimeStart = this.selectForm.addedTime[0] + ' 00:00:00'
                addedTimeEnd = this.selectForm.addedTime[1] + ' 23:59:59'
            }
            let createTimeStart = ''
            let createTimeEnd = ''
            if (this.selectForm.createTime) {
                createTimeStart = this.selectForm.createTime[0] + ' 00:00:00'
                createTimeEnd = this.selectForm.createTime[1] + ' 23:59:59'
            }

            let params = {
                bannerTitle: this.selectForm.bannerTitle,
                status: this.selectForm.status,
                uploader: this.selectForm.uploader,
                addedTimeStart: addedTimeStart,
                addedTimeEnd: addedTimeEnd,
                createTimeStart: createTimeStart,
                createTimeEnd: createTimeEnd,
                size: this.page.pageSize,
                current: this.page.current
            }
            this.loading = true
            this.dataList = []
            const { results, total } = await postBannerList(params)
            if (results.length > 0) {
                for (let i = 0; i < results.length; i++) {
                    if (results[0].priority !== 0 && this.page.current === 1) {
                        this.$set(results[0], 'noMoveUp', true)
                    }
                    if (results[i].priority === 1) {
                        this.$set(results[i], 'noMoveDown', true)
                    }
                }
                this.loading = false
                this.dataList = results
                this.page.total = total
            } else {
                if (this.page.current > 1) {
                    this.page.current -= 1
                    this.queryBannerList()
                }
            }
            this.queryShow()
            this.loading = false
        },
        init () {
            this.queryBannerList()
        }
    },
    mounted () {
        this.init()
    }
}
</script>

<style lang="scss">
.banner-wrap {
    .banner-content {
        min-height: 600px;
        box-shadow: 0 1px 4px 0 rgba(202, 202, 202, 0.5);
        margin: 20px;
        padding: 20px 20px 0 20px;
        background: #fff;
        overflow: auto;
        .title-wrap {
            font-size: 0;
            padding-bottom: 20px;
            height: 16px;
            line-height: 16px;
            .icon-tongyongbiaotiicon {
                color: $color-primary;
                font-size: 16px;
                vertical-align: middle;
            }
            .title-text {
                font-size: 14px;
                color: #333333;
                margin-left: 10px;
                display: inline-block;
                height: 16px;
                line-height: 16px;
                vertical-align: middle;
            }
        }

        .search-wrap {
            display: flex;
            justify-content: space-between;
            .search-show-wrap {
                display: flex;
            }
            .more-search {
                font-size: 0;
                color: #666;
                padding-left: 10px;
                cursor: pointer;
            }
            .more-search-text {
                font-size: 14px;
                line-height: 32px;
                padding-right: 3px;
            }
            .icon-drop_down {
                display: inline-block;
                font-size: 12px;
                color: #999;
                transition: transform 0.3s;
                transform: rotateZ(180deg);
                &.is-reverse {
                    transform: rotateZ(0deg);
                }
            }
        }
        .hide-wrap {
            margin-top: 8px;
            background: #f7f7f7;
            border: 1px solid #e6e6e6;
            padding-left: 20px;
            .option-wrap {
                display: flex;
                flex-wrap: wrap;
                &:last-child {
                    margin-bottom: 0;
                }
                .option-item {
                    display: inline-block;
                    font-size: 0;
                    margin: 20px 20px 20px 0;
                    .label {
                        padding-right: 10px;
                        font-size: 14px;
                        color: #666;
                        display: inline-block;
                        width: 76px;
                        text-align: right;
                    }
                    &:last-child {
                        margin-right: 0;
                    }
                    .el-select {
                        margin-right: 10px;
                        &:last-child {
                            margin-right: 0;
                        }
                    }
                    .el-input {
                        margin-right: 10px;
                        .el-input__inner {
                            height: 32px;
                        }
                    }
                    .el-date-editor {
                        margin-right: 10px;
                    }
                }
                .select-btn-wrap {
                    font-size: 0;
                    margin-top: 20px;
                    .el-button--small {
                        width: 80px;
                        padding: 8px 15px;
                        font-size: 14px;
                    }
                    .el-button--info.is-plain {
                        background: #f5f5f5;
                        border-color: #cccccc;
                        color: #666;
                    }
                }
            }
        }

        .table-wrap {
            margin-top: 20px;
            .table-none {
                height: 400px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                .icon {
                    font-size: 100px;
                }
                span {
                    line-height: 14px;
                }
            }
            .link-btn {
                color: $a-link;
                cursor: pointer;
                font-size: 12px;
                display: inline-block;
                height: 14px;
                line-height: 14px;
                border-right: 1px solid $a-link;
                margin-right: 6px;
                padding-right: 6px;
                &:last-child {
                    border-right: none;
                    margin-right: 0;
                    padding-right: 0;
                }
            }
            .image_title {
                display: flex;
                align-content: center;
                .cover-picture {
                    width: 70px;
                    height: 70px;
                }
                .text_title {
                    margin-left: 14px;
                    height: 70px;
                    width: 144px;
                    display: flex;
                    align-items: center;
                    .image_text {
                        font-family: PingFangSC-Regular;
                        font-size: 12px;
                        color: #333333;
                        line-height: 18px;
                        overflow: hidden;
                        word-break: break-all;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                    }
                }
            }

            .status-warp {
                line-height: 12px;
                .el-badge {
                    height: 10px;
                    .el-badge__content {
                        width: 6px;
                        height: 6px;
                    }
                    .el-badge__content--success {
                        background: #4acfb1;
                    }
                    .el-badge__content--info {
                        background: #cccccc;
                    }
                }
                .status_text {
                    margin-left: 10px;
                    font-family: PingFangSC-Regular;
                    font-size: 12px;
                    color: #333333;
                    line-height: 12px;
                }
            }

            .status-on {
                .icon-off {
                    color: #ccc;
                }
                .icon-on {
                    cursor: pointer;
                    color: #3b8fd9;
                }
                .icon-paixuxia {
                    font-size: 16px;
                }
                .icon-paixushang {
                    font-size: 16px;
                    margin-right: 20px;
                }
            }
            .status-off {
                .icon-paixuxia {
                    font-size: 16px;
                    color: #ccc;
                }
                .icon-paixushang {
                    font-size: 16px;
                    color: #ccc;
                    margin-right: 20px;
                }
            }
        }
    }
}
</style>
